
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/overview",
      function () {
        return require("private-next-pages/ai-decisioning/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/overview"])
      });
    }
  